export default function FoundationStory() {
  return (
    <section className="py-24 bg-[#1A0A1E]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Section label */}
        <div className="flex items-center gap-4 mb-16">
          <div className="w-10 h-px bg-[#7B2D8B]"></div>
          <span className="text-xs font-semibold uppercase tracking-[4px] text-[#C084FC]">Our Foundation</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          {/* Left: Story text */}
          <div>
            <h2 className="text-4xl md:text-5xl font-extrabold text-white leading-tight mb-8">
              Born from a Need<br />
              <span className="text-[#C084FC]">Too Long Ignored</span>
            </h2>

            <div className="space-y-5 text-gray-400 leading-relaxed text-sm">
              <p>
                Epilepsy affects over <strong className="text-white">50 million people globally</strong> — yet in Africa, it remains one of the most misunderstood, stigmatized, and neglected neurological conditions. Families hide their loved ones. Communities cast out those who seize. Myths replace medicine.
              </p>
              <p>
                IKIRU – The Epilepsy Foundation was established to confront this reality head-on. Our name, <em className="text-[#C084FC]">IKIRU</em>, embodies the spirit of living fully — because every person with epilepsy deserves exactly that: a full, dignified, empowered life.
              </p>
              <p>
                We exist to fundamentally change the narrative around epilepsy in Africa, fostering an environment of understanding, compassionate care, and systemic advocacy. Through education, medical support, community empowerment, and policy influence, we are building a future where epilepsy is no longer a sentence — but a condition that is managed, understood, and lived with dignity.
              </p>
              <p>
                Our work spans awareness campaigns in schools, medication assistance for patients, capacity training for healthcare workers, and direct engagement with policymakers. Every action we take is rooted in one belief: <strong className="text-white">no one should face epilepsy alone.</strong>
              </p>
            </div>

            {/* Purple ribbon awareness note */}
            <div className="mt-10 flex items-start gap-4 p-5 rounded-2xl bg-[#7B2D8B]/15 border border-[#7B2D8B]/30">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#7B2D8B]/30 shrink-0">
                <i className="ri-heart-fill text-[#C084FC] text-lg"></i>
              </div>
              <div>
                <div className="text-white font-semibold text-sm mb-1">The Purple Ribbon</div>
                <div className="text-gray-400 text-xs leading-relaxed">
                  Purple is the global color of epilepsy awareness — symbolizing strength, courage, and solidarity. IKIRU proudly carries this color as a commitment to every person living with epilepsy.
                </div>
              </div>
            </div>
          </div>

          {/* Right: Real outreach photo collage */}
          <div className="grid grid-cols-2 gap-4">
            <div className="rounded-2xl overflow-hidden h-64">
              <img
                src="https://storage.readdy-site.link/project_files/1c0c504f-5b8b-4291-9378-19346b5e3acb/23355b8b-23c4-4057-afc3-7facdfd4689c_WhatsApp-Image-2026-04-11-at-6.07.34-PM.jpeg?v=e21114373f32d607bc2ed10c1e28540c"
                alt="Ammuna Abubakar - Founder IKIRU Epilepsy Foundation"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="rounded-2xl overflow-hidden h-64 mt-8">
              <img
                src="https://storage.readdy-site.link/project_files/1c0c504f-5b8b-4291-9378-19346b5e3acb/WhatsApp-Image-2026-04-11-at-6.22.38-PM-1.jpeg?v=outreach01"
                alt="IKIRU epilepsy awareness outreach - community members holding awareness signs"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="rounded-2xl overflow-hidden h-48 col-span-2">
              <img
                src="https://storage.readdy-site.link/project_files/1c0c504f-5b8b-4291-9378-19346b5e3acb/WhatsApp-Image-2026-04-11-at-6.22.29-PM.jpeg?v=outreach02"
                alt="IKIRU outreach team at community awareness event Kano Nigeria"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
